(ns common.schema.entities.screening-profile.core
  (:require
   [clojure.string :as string]
   [common.schema.entities.screening-profile.permissions :as permissions]
   [common.schema.entities.screening-profile.schema :as schema]
   [common.util :as cu]))

(def entity-type-definition
  {:entity-type                  :entity.type/screening-profile
   :schema                       schema/schema
   :name                         {:en "Screening profile"}
   :plural                       {:en "Screening profiles"}
   :icon                         :fa-edit

   ;; FE+BE can build name from these without custom code
   :display-name-fn              (fn [{:keys [entity]}]
                                   (or (:screening-profile/company-name entity)
                                       (->> [(:screening-profile/first-name entity)
                                             (:screening-profile/last-name entity)]
                                            (remove cu/blank-value?)
                                            (string/join " "))))
   :display-name/depends-on      [:screening-profile/name
                                  :screening-profile/company-name
                                  :screening-profile/first-name
                                  :screening-profile/last-name]

   :search                       {:result/title-attr     :screening-profile/name ;; can we remove
                                  :result/subtitle-attrs [:screening-profile/sanction-status] ;; can we remove?
                                  :list/default-columns  [:screening-profile/name
                                                          :screening-profile/sanction-status
                                                          :common/updated-on]
                                  :list/default-sort     [:common/updated-on :desc] ;; nested sorting ?
                                  :quick-filters         [:screening-profile/sanction-status] ;; can this be removed after OS transition complete

                                  ;; WIP - design for list configurations is not ready - so not sure what needs to be configurable
                                  :views                 {:grid    {:po-default-field-paths [[:screening-profile/name]
                                                                                             [:screening-profile/sanction-status]
                                                                                             [:screening-profile/screening-status]
                                                                                             [:common/updated-on]]
                                                                    :mandatory-field-paths [[:screening-profile/name]
                                                                                            [:screening-profile/screening-status]]
                                                                    :pinned-field-paths    {:left  [[:screening-profile/name]]
                                                                                            :right [[:screening-profile/screening-status]]}}
                                                          :list    {:card {:header-fields [:screening-profile/name]
                                                                           :body-fields   [:screening-profile/sanction-status
                                                                                           :screening-profile/screening-status
                                                                                           :screening-profile/type]
                                                                           :footer-fields [:common/updated-on]}}
                                                          :gallery {:card {:header-fields [:screening-profile/name]
                                                                           :body-fields   [:screening-profile/sanction-status
                                                                                           :screening-profile/screening-status
                                                                                           :screening-profile/type]
                                                                           :footer-fields [:common/updated-on]}}
                                                          :kanban  {:group-by-field :screening-profile/screening-status
                                                                    :card           {:header-fields [:screening-profile/name]
                                                                                     :body-fields   [:screening-profile/sanction-status
                                                                                                     :screening-profile/screening-status
                                                                                                     :screening-profile/type]
                                                                                     :footer-fields [:common/updated-on]}}}}

   ;; backwards compatibility -> hopefully this can be removed at some point
   :reporting                    {:export/default-fields
                                  [:screening-profile/name
                                   :screening-profile/sanction-status
                                   :common/created-on
                                   :common/updated-on]
                                  :export/filename-template "screening_profiles_{{date}}.csv"}

   ;; WIP -> we need better scheme for modelling permissions
   ;; rethinking with field permission on create vs update use cases
   :permissions                  {:creatable?   true
                                  :disableable? true}

   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
